import { render, staticRenderFns } from "./WorkDescriptionGroupSelect.vue?vue&type=template&id=40bd117a&scoped=true&"
import script from "./WorkDescriptionGroupSelect.vue?vue&type=script&lang=js&"
export * from "./WorkDescriptionGroupSelect.vue?vue&type=script&lang=js&"
import style0 from "./WorkDescriptionGroupSelect.vue?vue&type=style&index=0&id=40bd117a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd117a",
  null
  
)

export default component.exports